"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDraggable = _interopRequireWildcard(require("react-draggable"));

var _stream = require("stream");

var _color = _interopRequireDefault(require("color"));

var _styles = require("@material-ui/core/styles");

var _getImagePoint = require("../../Media/utils/getImagePoint");

var _DragHandle = _interopRequireDefault(require("@material-ui/icons/DragHandle"));

var _RemoveCircle = _interopRequireDefault(require("@material-ui/icons/RemoveCircle"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    position: "absolute",
    top: props => {
      return props.top + "%" || "50%";
    },
    left: props => {
      return props.left + "%" || "50%";
    },
    zIndex: props => {
      return props.zIndex;
    }
  },
  shape: {
    position: "absolute",
    top: "100%",
    left: "100%",
    width: theme.spacing(2),
    height: theme.spacing(2),
    backgroundColor: props => {
      return props.color;
    }
  },
  size: {
    display: "block",
    position: "absolute",
    top: "0",
    left: "0",
    width: props => {
      return props.shape === "circle" && theme.spacing(props.size) || theme.spacing(props.width);
    },
    height: props => {
      return props.shape === "circle" && theme.spacing(props.size) || theme.spacing(props.height);
    },
    [theme.breakpoints.up('sm')]: {
      width: props => {
        return props.shape === "circle" && theme.spacing(props.size * 1.5) || theme.spacing(props.width * 1.5);
      },
      height: props => {
        return props.shape === "circle" && theme.spacing(props.size * 1.5) || theme.spacing(props.height * 1.5);
      }
    },
    [theme.breakpoints.up('md')]: {
      width: props => {
        return props.shape === "circle" && theme.spacing(props.size * 2) || theme.spacing(props.width * 2);
      },
      height: props => {
        return props.shape === "circle" && theme.spacing(props.size * 2) || theme.spacing(props.height * 2);
      }
    },
    position: "absolute",
    display: "block",
    transform: "translate(-50%, -50%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& $colors": {
      display: "none"
    },
    "&:hover $colors": {
      display: "flex"
    },
    "& $removeButton": {
      display: "none"
    },
    "&:hover $removeButton": {
      display: "flex"
    },
    "& $handleButton": {
      display: "none"
    },
    "&:hover $handleButton": {
      display: "flex"
    },
    "&:hover $shape": {
      backgroundColor: props => {
        return props.hoverColor;
      },
      //            borderColor: "transparent",
      borderStyle: "dotted"
    },
    "&:hover $labelButton": {}
  },
  shape: {
    display: "block",
    position: "absolute",
    top: props => {
      return props.shape === "circle" && 0 || theme.spacing(.5);
    },
    right: props => {
      return props.shape === "circle" && 0 || theme.spacing(.5);
    },
    bottom: props => {
      return props.shape === "circle" && 0 || theme.spacing(.5);
    },
    left: props => {
      return props.shape === "circle" && 0 || theme.spacing(.5);
    },
    border: "2px solid",
    color: props => {
      return props.contrastColor;
    },
    borderColor: props => {
      return props.color;
    },
    borderRadius: props => {
      return props.shape === "circle" && "50%" || "0";
    },
    "&:hover": {
      cursor: props => {
        return props.cursor || "move";
      }
    }
  },
  labelButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Akkurat Mono, monspace",
    fontSize: "14px",
    width: props => {
      return props.shape === "circle" && theme.spacing(3.5) || theme.spacing(4);
    },
    height: props => {
      return props.shape === "circle" && theme.spacing(3.5) || theme.spacing(4);
    },
    backgroundColor: props => {
      return props.color;
    },
    border: "1px solid",
    borderColor: props => {
      return props.color;
    },
    color: props => {
      return props.contrastColor;
    },
    borderRadius: props => {
      return props.shape === "rectangle" && "50%" || "0";
    }
  },
  removeButton: {
    position: "absolute",
    top: theme.spacing(-2),
    right: theme.spacing(-2)
  },
  removeShape: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: props => {
      return props.color;
    },
    width: "18px",
    height: "18px",
    borderRadius: "9px"
  },
  removeIcon: {
    display: "block",
    backgroundColor: props => {
      return props.contrastColor || theme.palette.text.primary;
    },
    width: "9px",
    height: "2px"
  },
  colors: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  colorButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  colorIcon: {
    display: "block",
    backgroundColor: props => {
      return props.color;
    },
    width: theme.spacing(1.5),
    height: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    margin: theme.spacing(1)
  },
  handleButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: props => {
      return props.top && "0" || "auto";
    },
    right: props => {
      return props.right && "0" || "auto";
    },
    bottom: props => {
      return props.bottom && "0" || "auto";
    },
    left: props => {
      return props.left && "0" || "auto";
    },
    margin: theme.spacing(-1)
  },
  handleIcon: {
    display: "block",
    backgroundColor: props => {
      return props.color;
    },
    width: theme.spacing(1),
    height: theme.spacing(1),
    margin: theme.spacing(1)
  }
}));

const ButtonHandle = ({
  color,
  top,
  right,
  bottom,
  left,
  onResize
}) => {
  const classes = useStyles({
    color,
    top,
    left,
    bottom,
    right
  });

  const handleResize = ({
    x,
    y
  }) => {
    if (left) {
      x = x * -1;
    }

    if (top) {
      y = y * -1;
    }

    onResize && onResize({
      x,
      y
    });
  };

  const handleStart = (event, data) => {
    console.log('OnStart', data); //        handleResize(data)
  };

  const handleDrag = (event, data) => {
    console.log('oNDrag', data);
  };

  const handleStop = (event, data) => {
    console.log('onStop', data);
    handleResize(data);
  };

  return _react.default.createElement(_reactDraggable.default, {
    onStart: handleStart,
    onDrag: handleDrag,
    onStop: handleStop
  }, _react.default.createElement(_ButtonBase.default, {
    className: classes.handleButton
  }, _react.default.createElement("i", {
    className: classes.handleIcon
  })));
};

const ButtonLabel = ({
  index,
  color,
  contrastColor,
  shape,
  onClick
}) => {
  const classes = useStyles({
    color,
    contrastColor,
    shape
  });
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.labelButton,
    onClick: onClick
  }, index + 1);
};

const ButtonRemove = ({
  className,
  color,
  contrastColor,
  onClick
}) => {
  const classes = useStyles({
    color,
    contrastColor
  });
  return _react.default.createElement(_IconButton.default, {
    className: className || classes.removeButton,
    onClick: onClick
  }, _react.default.createElement("b", {
    className: classes.removeShape
  }, _react.default.createElement("i", {
    className: classes.removeIcon
  })));
};

const ButtonColor = ({
  color,
  onClick
}) => {
  const classes = useStyles({
    color
  });
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.colorButton,
    onClick: color && onClick
  }, _react.default.createElement("i", {
    className: classes.colorIcon
  }));
};

const ImageAnnotationsMarker = (_ref) => {
  let index = _ref.index,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? 50 : _ref$top,
      _ref$left = _ref.left,
      left = _ref$left === void 0 ? 50 : _ref$left,
      onStart = _ref.onStart,
      onDrag = _ref.onDrag,
      onStop = _ref.onStop,
      props = _objectWithoutPropertiesLoose(_ref, ["index", "top", "left", "onStart", "onDrag", "onStop"]);

  const colors = ["white", "#bbb", "#777", "#333", "black", "red", "green", "blue", "#FF8080", "#80FF80", "#8080FF", "yellow", "#0ff", "#f0f", "#ffff08", "#08ffff", "#ff08ff"];

  const _useState = (0, _react.useState)({
    top: top,
    left: left
  }),
        coords = _useState[0],
        setCoords = _useState[1];

  const _useState2 = (0, _react.useState)("grab"),
        cursor = _useState2[0],
        setCursor = _useState2[1];

  const _useState3 = (0, _react.useState)(props.shape || "circle"),
        shape = _useState3[0],
        setShape = _useState3[1];

  const _useState4 = (0, _react.useState)(props.size || 8),
        size = _useState4[0],
        setSize = _useState4[1];

  const _useState5 = (0, _react.useState)(props.width || props.size || 8),
        width = _useState5[0],
        setWidth = _useState5[1];

  const _useState6 = (0, _react.useState)(props.height || props.size || 8),
        height = _useState6[0],
        setHeight = _useState6[1];

  const _useState7 = (0, _react.useState)(props.color || color[0]),
        color = _useState7[0],
        setColor = _useState7[1];

  const _useState8 = (0, _react.useState)(color[0]),
        contrastColor = _useState8[0],
        setContrastColor = _useState8[1];

  const _useState9 = (0, _react.useState)(color[0]),
        borderColor = _useState9[0],
        setBorderColor = _useState9[1];

  const _useState10 = (0, _react.useState)(color[0]),
        nextColor = _useState10[0],
        setNextColor = _useState10[1];

  const _useState11 = (0, _react.useState)(color[0]),
        prevColor = _useState11[0],
        setPrevColor = _useState11[1];

  const _useState12 = (0, _react.useState)(color[0]),
        hoverColor = _useState12[0],
        setHoverColor = _useState12[1];

  (0, _react.useEffect)(() => {
    //        setCoords({top: top, left: left})
    setContrastColor((0, _color.default)(color).isDark() && "white" || "black");
    setBorderColor((0, _color.default)(color).isDark() && "rgba(255,255,255,.5)" || "rgba(0,0,0,.5)");
    setHoverColor((0, _color.default)(color).alpha(0.25).rgb().string());
    setNextColor(colors[colors.indexOf(color) + 1] || colors[0]);
    setPrevColor(colors[colors.indexOf(color) - 1] || colors[colors.length - 1]);
  }, [color, top, left, index]);

  const toggleColor = color => {
    setColor(color);
  };

  const toggleShape = () => {
    if (shape === "circle") {
      setShape('rectangle');
      setWidth(size);
      setHeight(size);
    } else {
      setShape('circle');
      setSize((width + height) / 2);
    }
  };

  const handleStart = event => {
    setCursor('grabbing');
    onStart && onStart(event);
  };

  const handleDrag = event => {
    onDrag && onDrag(event);
  };

  const handleStop = event => {
    setCursor('grab');
    onStop && onStop(event); //        const marker = getImagePointEvent(event)
    //        setCoords(marker)
  };

  const handleResize = ({
    x,
    y
  }) => {
    const newWidth = width + x / 8;
    const newHeight = height + y / 8;
    setWidth(newWidth);
    setHeight(newHeight);
    setSize((newWidth + newHeight) / 2);
  };

  const classes = useStyles(_extends({
    size,
    width,
    height,
    zIndex: index,
    color,
    contrastColor,
    hoverColor,
    cursor,
    shape
  }, coords));
  return _react.default.createElement(_reactDraggable.default, {
    bounds: "parent",
    handle: ".draghandle",
    onStart: handleStart,
    onDrag: handleDrag,
    onStop: handleStop
  }, _react.default.createElement("div", {
    className: classes.root
  }, _react.default.createElement("div", {
    className: classes.size
  }, _react.default.createElement("div", {
    className: classes.shape + " draghandle"
  }), _react.default.createElement(ButtonHandle, {
    top: true,
    left: true,
    color: color,
    onResize: handleResize
  }), _react.default.createElement(ButtonHandle, {
    bottom: true,
    left: true,
    color: color,
    onResize: handleResize
  }), _react.default.createElement(ButtonHandle, {
    bottom: true,
    right: true,
    color: color,
    onResize: handleResize
  }), _react.default.createElement(ButtonRemove, {
    className: classes.removeButton,
    color: color,
    contrastColor: contrastColor
  }), _react.default.createElement("div", {
    className: classes.colors
  }, _react.default.createElement(ButtonColor, {
    color: prevColor,
    onClick: () => toggleColor(prevColor)
  }), _react.default.createElement(ButtonLabel, {
    shape: shape,
    color: color,
    contrastColor: contrastColor,
    index: index,
    onClick: toggleShape
  }), _react.default.createElement(ButtonColor, {
    color: nextColor,
    onClick: () => toggleColor(nextColor)
  })))));
};

ImageAnnotationsMarker.defaultProps = {
  color: "white"
};
var _default = ImageAnnotationsMarker;
exports.default = _default;
module.exports = exports.default;